import {createContextualCan} from '@casl/react'
import {Ability, AbilityBuilder} from '@casl/ability'
import get from 'lodash/get'
import Keycloak from 'keycloak-js'
import {AbilityContext} from './AbilityContext'

interface IAuthDef {
  actions: string[]
  subject: string
}

interface IAuthRoles {
  roles: Record<string, Array<IAuthDef>>
}

export interface IRealmAuth extends Record<string, IAuthRoles> {}

// Defines how to detect object's type
// function subjectName(item: any) {
//     if (!item || typeof item === "string") {
//         return item
//     }
//     return item.__type
// }


export const collectsRoles = (
  // application: string,
  token: Keycloak.KeycloakInstance
): string[] => {
  let roles: string[] =
    token !== undefined && token.realmAccess !== undefined ? token.realmAccess.roles : []

  if (token && token.tokenParsed) {
    let tokenParsed: any = token.tokenParsed

    if (tokenParsed.resource_access) {
      const applicationResource = get(tokenParsed.resource_access, 'application')
      const applicationRoles =
        applicationResource !== undefined ? get(applicationResource, 'roles') : undefined

      if (applicationRoles !== undefined) {
        roles.push(...applicationRoles)
      }

    }
  }
  return roles
}

export const updateAbilityFromToken = (
  restrictions: IRealmAuth,
  token: Keycloak
) => {
  const { can, build } = new AbilityBuilder(Ability)
  const { realm } = token

  const tokenRoles: string[] = collectsRoles(token)

  //console.log('TokenRoles: ', tokenRoles)


  for (let i = 0; i < tokenRoles.length; i++) {
    if (realm) {
      const roles: Array<IAuthDef> = restrictions[realm].roles[tokenRoles[i]]
      if (roles !== undefined) {
        for (let r = 0; r < roles.length; r++) {
          const role: IAuthDef = roles[r]
          const { subject, actions } = role
          for (let a = 0; a < actions.length; a++) {
            //console.log('CAN: ', actions[a],subject);
            can(actions[a], subject)
          }
        }
      }
    }
  }

  //ability.update(rules)
  return build()
}

export const Can = createContextualCan(AbilityContext.Consumer)
